<template>
  <div class="report-record">
    <NavBar
      :showBack="type === '0'"
      class="nav"
      :title="`${$t('record.工单记录')}-${ticket.group_name || ''}`"
      :goBack="onClickLeft"
    />
    <Notice :top="noticeTop" />
    <div class="content">
      <!-- 处理进度 -->
      <div class="process section-box marginB10">
        <div class="steps">
          <div
            :class="[
              'step',
              index === currentStep
                ? 'step-active'
                : index > currentStep
                ? 'step-not'
                : '',
            ]"
            v-for="(item, index) in processSteps"
            :key="item.type"
          >
            <div class="step-circle-container">
              <div class="step-circle"></div>
            </div>
            <div
              class="step-line"
              :style="{ width: lineWidth + 'px' }"
              v-if="index < 2"
            ></div>
            <div class="step-title" v-if="item.content && item.add_time">
              <span>{{ item.content }}</span>
              <span>{{ item.add_time | timeFilter("MM/DD HH:mm") }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 补全提示 -->
      <div class="complete-box section-box marginB10" v-if="isComplete">
        <div class="title">{{ $t("record.补全提示") }}</div>
        <div class="tips">
          {{ completeTips }}
        </div>
        <van-form ref="form" @submit="handleSubmit">
          <template v-for="(item, index) in needFields">
            <van-field
              :readonly="['qd'].includes(item.key)"
              :clickable="['qd'].includes(item.key)"
              :type="item.key === 'remark' ? 'textarea' : 'text'"
              @click="onClickItem(item, index)"
              :key="index"
              :required="item.key != 'remark'"
              v-model="item.text"
              :label="item.val"
              :placeholder="`${$t('record.请填写')}${item.val}`"
            >
              <template #input v-if="item.key === 'files'">
                <van-uploader v-model="item.fileList" :after-read="afterRead" />
              </template>
            </van-field>
          </template>
          <div class="footer t-center">
            <van-button
              :loading="comLoading"
              style="width: 50%; height: 37px"
              size="large"
              type="primary"
              native-type="submit"
              >{{ $t("record.提交") }}</van-button
            >
          </div>
        </van-form>
      </div>
      <!-- 处理结果 -->
      <div
        class="result section-box marginB10"
        v-if="
          ticket &&
          ticket.disabled !== 1 &&
          ticket.status === 2 &&
          ticket.do_result
        "
      >
        <div class="title">{{ $t("record.处理结果") }}</div>
        <div class="infos">{{ ticket.do_result }}</div>
        <div
          class="result-opinion"
          v-if="type === '1' && score.status !== 2 && lang !== 'en'"
        >
          <div class="head">
            {{
              ticket.types === 3
                ? $t("record.若未能解决您的问题")
                : $t("record.您对处理结果满意吗")
            }}
          </div>
          <div class="res-body">
            <div class="btns marginB10" v-if="ticket.types !== 3">
              <div class="marginR15 flex-1">
                <van-button
                  @click="handleActiveItem(1)"
                  :class="activeItem === 1 ? 'active' : 'default'"
                  type="primary"
                  >{{ $t("record.满意") }}</van-button
                >
              </div>
              <div class="flex-1">
                <van-button
                  @click="handleActiveItem(-1)"
                  :class="activeItem === -1 ? 'active' : 'default'"
                  type="primary"
                  >{{ $t("record.不满意") }}</van-button
                >
              </div>
            </div>
            <div
              class="dislike-rate"
              v-if="activeItem === -1 && ticket.types !== 3"
            >
              <div
                class="rate-line"
                v-for="(item, index) in rateFormArr"
                :key="index"
              >
                <span class="label">{{ item.val }}</span>
                <van-rate class="rate-item" v-model="item.rate" />
              </div>
            </div>
            <div class="checkbox-box marginB10" v-if="ticket.types === 3">
              <van-checkbox-group
                direction="horizontal"
                v-model="unsolvedReason"
              >
                <van-checkbox
                  shape="square"
                  v-for="item in willingItems.unsolved"
                  :name="item.val"
                  :key="item.key"
                  >{{ item.val }}</van-checkbox
                >
                <van-checkbox shape="square" name="other" key="other">{{
                  $t("record.其他")
                }}</van-checkbox>
              </van-checkbox-group>
            </div>
            <div class="submit" v-if="activeItem || ticket.types == 3">
              <van-field
                :placeholder="$t('record.请您填写您的建议以便我们后续优化')"
                type="textarea"
                v-if="
                  (ticket.types == 3 && unsolvedReason.includes('other')) ||
                  ticket.types !== 3
                "
                autosize
                rows="2"
                v-model="otherValue"
              />
              <van-button
                type="primary"
                :loading="rateLoading"
                @click="handleScore"
                >{{ $t("record.提交") }}</van-button
              >
            </div>
          </div>
        </div>
        <div
          class="result-info marginT10"
          v-if="score.status === 2 && ticket.types !== 3"
        >
          <div class="result-title">{{ $t("record.您对处理结果满意吗") }}?</div>
          <div class="result-desc">{{ scoreInfo }}</div>
        </div>
        <!-- 自助工单 处理结果 -->
        <div
          class="result-info marginT10"
          v-if="score.status === 2 && ticket.types == 3"
        >
          <div class="result-title">{{ $t("record.若未能解决您的问题") }}</div>
          <div class="result-desc">{{ score.reason }}</div>
        </div>
      </div>

      <!-- 是否愿意继续使用 -->
      <div
        class="result-opinion section-box marginB10"
        v-if="type === '1' && score.status === 2 && ticket.types !== 3"
      >
        <!-- 有结果就显示结果 -->
        <template v-if="ticket.status === 2 && ticket.willing !== 0">
          <div class="result-info marginT10">
            <div class="result-title">{{ $t("record.您愿意继续使用吗") }}?</div>
            <div class="result-desc">
              {{
                `${
                  ticket.willing === 1 ? $t("record.愿意") : $t("record.不愿意")
                }${$t("record.继续使用该服务")}`
              }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="title">{{ $t("record.您愿意继续使用吗") }}?</div>
          <div class="res-body">
            <div class="btns">
              <div class="flex-1 marginR15">
                <van-button
                  @click="handleActiveWilling(1)"
                  :class="willingItem === 1 ? 'active' : 'default'"
                  type="primary"
                  >{{ $t("record.愿意") }}</van-button
                >
              </div>
              <div class="flex-1">
                <van-button
                  @click="handleActiveWilling(-1)"
                  :class="willingItem === -1 ? 'active' : 'default'"
                  type="primary"
                  >{{ $t("record.不愿意") }}</van-button
                >
              </div>
            </div>
          </div>
        </template>
        <template v-if="ticket.status === 2 && ticket.willing_reason">
          <div class="result-info">
            <div class="result-title">{{ $t("record.你对服务的评价是") }}</div>
            <div class="result-desc">{{ ticket.willing_reason }}</div>
          </div>
        </template>
        <template v-else>
          <template v-if="willingItem === -1 || willingItem === 1">
            <div class="head marginB10">
              {{ $t("record.你对服务的评价是") }}
            </div>
            <div class="res-body">
              <div class="checkbox-box">
                <van-checkbox-group
                  direction="horizontal"
                  v-model="willingReason"
                >
                  <van-checkbox
                    shape="square"
                    v-for="item in willingItem == 1
                      ? willingItems.good
                      : willingItems.bad"
                    :name="item.val"
                    :key="item.key"
                    >{{ item.val }}</van-checkbox
                  >
                </van-checkbox-group>
              </div>
              <div class="will-submit" v-if="willingItem">
                <van-button
                  type="primary"
                  :loading="willingLoading"
                  @click="handleWilling"
                  >{{ $t("record.提交") }}</van-button
                >
              </div>
            </div>
          </template>
        </template>
      </div>

      <!-- 工单详情 -->
      <div class="list-box section-box">
        <div class="title border">{{ $t("record.工单详情") }}</div>
        <van-cell :title="$t('record.问题描述')" :value="ticket.desc" />
        <van-cell :title="$t('record.游戏名称')" :value="ticket.game_name" />
        <van-cell :title="$t('record.来访分类')" :value="ticket.group_name" />
        <van-cell :title="$t('record.二级分类')" :value="ticket.reason" />
        <van-cell :title="$t('record.角色区服')" :value="ticket.server_name" />
        <van-cell :title="$t('record.角色ID')" :value="ticket.role_id" />
        <van-cell :title="$t('record.角色名称')" :value="ticket.role_name" />
        <van-cell
          :title="$t('record.文件')"
          v-if="ticket.files && ticket.files.length"
        >
          <div class="file-box" slot="default" @click="handleImage">
            <img v-for="item in ticket.files" :src="item" :key="item" alt="" />
          </div>
        </van-cell>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        value-key="name"
        @confirm="onConfirm"
        :loading="pickerLoading"
        @cancel="showPicker = false"
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('record.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ImagePreview } from "vant";
import { Notice } from "@/components/Notice";
import { uploadFileOss } from "@/utils/uploadOss";
import {
  getReportDetail,
  completeTicket,
  getGameChannel,
  getStarItem,
  apiTicketScore,
  getWillingReason,
  updateWilling,
  getTicketDetail,
} from "@/api/workOrder";

export default {
  name: "ReportResult",
  components: { Notice },
  data() {
    return {
      keyword: "",
      ratevalue: 0,
      showMore: false,
      showPicker: false,
      pickerLoading: false,
      // 评分 loading
      rateLoading: false,
      // 提交 loading
      comLoading: false,
      // 提交意愿 loading
      willingLoading: false,
      reportId: this.$route.query.id,
      type: this.$route.query.type.toString(),
      logs: [],
      ticket: {},
      isComplete: false,
      score: {},
      // 补全 tips
      completeTips: "",
      completeArr: [],
      // 已经存在的字段
      existFields: [],
      // 需要补全的 form
      needFields: [],
      // 渠道数据列表
      columns: [],
      // 当前点击行
      activeIndex: 0,
      // 当前点击满意不满意
      activeItem: "",
      // 自定义内容
      otherValue: "",
      // 是否愿意继续使用
      willingItem: "",
      // 是否愿意选项
      willingItems: {},
      // 是否愿意原因
      willingReason: [],
      // 未解决原因
      unsolvedReason: [],
      // 评分 form
      rateFormArr: [],
      processSteps: [{ type: 0 }, { type: 10 }, { type: 14 }],
      currentStep: 0,
      lineWidth: 140,
      lang: "",
    };
  },
  computed: {
    ...mapGetters(["vuexInitData"]),
    noticeTop() {
      // return Math.floor(this.outerWidth / 375 * 44);
      return 0;
    },
    currentColumns() {
      return this.columns.filter((item) => {
        const str = (item.name && item.name.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
    scoreInfo() {
      let res;
      if (this.ticket.types === 3) {
        if (this.score.score === 1) {
          res = `【${this.$t("record.已解决")}】`;
        } else {
          res = `【${this.$t("record.未解决")}】`;
        }
      } else {
        if (this.score.score === 1) {
          res = `【${this.$t("record.满意")}】`;
        } else {
          res = `【${this.$t("record.不满意")}】`;
        }
      }
      return res;
    },
  },
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  async created() {
    if (!this.vuexInitData.cpub) {
      await this.getKfInit();
    }
  },
  mounted() {
    const lang = localStorage.getItem("lang");
    this.lang = lang;
    this.getData();
    this.getWillings();
    this.$nextTick(() => {
      this.lineWidth =
        document.getElementsByClassName("process")[0] &&
        document.getElementsByClassName("process")[0].offsetWidth / 2 - 30;
    });
  },
  methods: {
    ...mapActions(["getKfInit"]),
    onClickLeft() {
      this.$router.back();
    },
    // 获取意愿项
    getWillings() {
      getWillingReason().then((res) => {
        this.willingItems = res.data || {};
      });
    },
    // 获取渠道
    getChannel() {
      getGameChannel().then((res) => {
        if (res.code === 0) {
          this.columns = res.data || [];
        }
      });
    },
    // 获取评分项
    getStarItems() {
      getStarItem().then((res) => {
        if (res.code === 0) {
          const arr =
            res.data && res.data.map((item) => ({ ...item, rate: 0 }));
          this.rateFormArr = arr || [];
        }
      });
    },
    // 选择是否愿意继续使用
    handleActiveWilling(type) {
      if (type === this.willingItem) {
        return;
      }
      this.willingItem = type;
      this.willingReason = [];
    },
    afterRead(file) {
      console.log({ file });
      file.status = "uploading";
      file.message = this.$t("record.上传中") + "...";
      let params = {
        file: file.file,
      };
      const _this = this;
      // console.log(1234, this.vuexInitData);
      uploadFileOss(params)
        .then((res) => {
          file.status = "success";
          file.message = "";
          file.url = res.key;
        })
        .catch((err) => {
          file.status = "failed";
          file.message = _this.$t("reportIndex.上传失败");
          this.$toast(_this.$t("reportIndex.上传失败"));
        });
    },
    onClickItem(item, index) {
      this.activeIndex = index;
      if (item.key === "qd") {
        this.showPicker = true;
      }
    },
    onConfirm(value) {
      this.showPicker = false;
      const obj = {
        ...this.needFields[this.activeIndex],
        text: value.name,
        value: value.id,
      };
      this.$set(this.needFields, this.activeIndex, obj);
    },
    getData() {
      if (!this.reportId) {
        return;
      }
      let params = {};
      if (this.type === "1") {
        params = {
          type: 1,
          code: this.reportId,
        };
      } else {
        params = {
          type: this.type,
          id: this.reportId,
        };
      }
      if (this.type === "1") {
        getTicketDetail(params).then((res) => {
          this.setDatas(res);
        });
      } else {
        getReportDetail(params).then((res) => {
          this.setDatas(res);
        });
      }
    },
    setDatas(res) {
      if (res.code === 0) {
        const result = res.data || {};
        this.logs = result.logs || [];

        this.currentStep = this.logs.length - 1;
        this.logs.forEach((log) => {
          this.processSteps.forEach((step) => {
            if (log.type === step.type) {
              step.content = log.content;
              step.add_time = log.add_time;
            }
          });
        });

        this.score = result.score || {};
        const ticket = result.ticket || {};
        ticket.files = (ticket.files && ticket.files.split(",")) || [];
        this.ticket = ticket;
        // this.type === '1' &&
        if (result.ticket && result.ticket.disabled === 1) {
          this.getChannel();
          this.isComplete = true;
          this.completeTips = result.tips ? result.tips.substring(5) : "";
          const { need_fields, exist_fields } = result.ticket;
          this.existFields = exist_fields;
          const arr =
            need_fields &&
            need_fields.map((item, index) => {
              if (item.key === "files") {
                return {
                  ...item,
                  text: "",
                  fileList: [],
                };
              } else {
                return {
                  ...item,
                  text: "",
                };
              }
            });
          arr.push({
            key: "remark",
            val: this.$t("record.补充说明"),
            text: "",
          });
          this.needFields = arr || [];
        } else {
          this.isComplete = false;
          this.needFields = [];
        }
        if (this.type === "1") {
          this.getStarItems();
          this.getWillings();
        }
      }
    },
    // 工单评分
    handleScore() {
      const params = {
        id: this.ticket.id,
        code: this.reportId,
        // 自助工单不选满意  不满意
        score: this.ticket.types === 3 ? -1 : this.activeItem,
        star_items: {},
      };
      // types 为 3 代表自助工单来的， 邀评会显示是否解决问题， 不用评分
      if (this.activeItem === -1 && this.ticket.types !== 3) {
        this.rateFormArr.forEach((item) => {
          params.star_items[item.key] = item.rate;
        });
      }
      if (this.activeItem === 1) {
        params.remark = this.otherValue;
      } else {
        params.reason = this.otherValue;
      }

      // 自助工单
      if (this.ticket.types === 3) {
        let uR = this.unsolvedReason.filter((r) => r !== "other");
        params.reason = uR.length
          ? uR.join(",") + "," + this.otherValue
          : this.otherValue;
      }
      this.rateLoading = true;
      apiTicketScore(params)
        .then((res) => {
          if (res.code === 0) {
            this.getData();
          }
        })
        .finally(() => {
          this.rateLoading = false;
        });
    },
    // 选择意愿
    handleWilling() {
      const params = {
        id: this.ticket.id,
        reason: this.willingReason.join(","),
        score: this.willingItem,
      };
      this.willingLoading = true;
      updateWilling(params)
        .then((res) => {
          if (res.code === 0) {
            this.getData();
          }
        })
        .finally(() => {
          this.willingLoading = false;
        });
    },
    handleActiveItem(item) {
      if (item === this.activeItem) {
        return;
      }
      this.activeItem = item;
      this.otherValue = "";
    },
    dealInfos(info) {
      if (info) {
        return info.replace(/[\r\n]/g, "<br/>");
      } else {
        return "";
      }
    },
    handleSubmit() {
      const params = {
        id: this.ticket.id,
        items: {},
      };
      this.needFields.forEach((item) => {
        if (item.key === "files") {
          params.items[item.key] = item.fileList;
        } else {
          params.items[item.key] = item.value || item.text;
        }
      });

      if (params.items.files && params.items.files.length > 0) {
        if (!params.items.files.every((item) => item.status === "success")) {
          this.$toast(this.$t("record.文件上传中"));
          return;
        }
        params.items.files = params.items.files
          .map((item) => {
            return item.url;
          })
          .join(",");
      }

      this.comLoading = true;
      completeTicket(params)
        .then((res) => {
          if (res.code === 0) {
            this.getData();
          }
        })
        .finally(() => {
          this.comLoading = false;
        });
    },
    // 预览图片
    handleImage() {
      if (this.ticket.files && this.ticket.files.length) {
        ImagePreview(this.ticket.files);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.report-record {
  display: flex;
  flex-direction: column;
  // width: 100%;
  height: 100%;
  // overflow: hidden;
  background: #f1f1f1;
  .nav {
    flex: 0 0 auto;
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    // box-sizing: border-box;
    overflow: auto;
    .list-box {
      width: calc(100% - 2px);
      padding: 1px;
      margin-bottom: 10px;
      .file-box {
        img {
          width: 60px;
          margin-right: 5px;
        }
      }
      /deep/ .van-cell {
        padding-left: 0;
        padding-right: 0;
        &::after {
          left: 0;
          right: 0;
        }
        .van-cell__title {
          margin-left: 10px;
        }
        .van-cell__value {
          margin-right: 10px;
        }
      }
    }
    .complete-box {
      width: 100%;
      padding-bottom: 10px;
      .tips {
        min-height: 40px;
        padding: 10px;
        margin: 0 10px;
        color: #aaaaaf;
        background: #f2f2f2;
        font-size: 12px;
        text-align: left;
      }
      .footer {
        margin-top: 10px;
        padding: 0 10px;
        box-sizing: border-box;
      }
    }
    .result {
      width: 100%;
      padding-bottom: 10px;
      .infos {
        margin: 0 10px;
        padding: 6px;
        background: #f0f5ff;
        color: @fontColor;
        font-size: 13px;
        line-height: 18px;
        border-radius: 4px;
        box-sizing: border-box;
      }
      .eval-res {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: @fontColor;
        font-size: 13px;
      }
    }
  }
  /deep/ .van-search {
    padding: 0;
  }
}
.result-opinion {
  width: 100%;
  // margin: 12px 10px 0 10px;
  // border-radius: 4px;
  // background-color: #fff;
  // box-sizing: border-box;
  .head {
    padding: 10px;
    color: @fontColor;
    font-size: 15px;
    border-bottom: 1px solid #f7f7f7;
  }
  .res-body {
    width: 100%;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
    .btns {
      width: 100%;
      // padding: 14px 0;
      border-bottom: 1px solid #f7f7f7;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      button {
        width: 100%;
        // flex: 1;
        height: 40px;
        color: #fff;
        font-size: 16px;
        background-color: #c0c0c0;
        border: none;
        &.active {
          background-color: #e64b5c;
        }
      }
    }
    .dislike-rate {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 14px 0;
      box-sizing: border-box;
      .rate-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 4px;
        font-size: 13px;
        .label {
          flex: 0 0 auto;
          width: 50%;
          text-align: center;
        }
        .rate-item {
          flex: 0 0 auto;
          width: 50%;
        }
      }
    }
    .checkbox-box {
      margin-top: 10px;
      /deep/ .van-checkbox {
        margin-bottom: 4px;
      }
    }
    .will-submit {
      display: flex;
      justify-content: center;
      // margin-top: 10px;
      button {
        width: 160px;
        height: 37px;
        font-size: 14px;
        margin-top: 12px;
      }
    }
    .submit {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      /deep/ .van-cell {
        background: #f2f2f2;
      }
      button {
        width: 160px;
        height: 37px;
        font-size: 14px;
        margin-top: 12px;
      }
    }
  }
}
.process {
  padding: 10px;
  width: calc(100% - 20px);
  .steps {
    display: flex;
    overflow: hidden;
    height: 50px;
    // margin-left: 20px;
    justify-content: space-between;
    .step {
      position: relative;
      // flex: 1;
      float: left;
      width: 70px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .step-circle-container {
        position: absolute;
        z-index: 1;
        left: 17px;
        padding: 0 10px;
        background: #fff;
        .step-circle {
          width: 13px;
          height: 13px;
          background: #797a8c;
          border-radius: 50%;
        }
      }
      .step-title {
        position: absolute;
        top: 17px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .step-line {
        position: absolute;
        top: 5px;
        left: 17px;
        width: 200%;
        // height: 1px;
        border-top: 1px dashed #dedede;
      }
      &.step-active {
        color: @gold;
        .step-line {
          border-color: @gold;
        }
        .step-circle {
          background: @gold;
        }
      }
      &.step-not {
        color: #dedede;
        .step-line {
          border-color: #dedede;
        }
        .step-circle {
          background: #dedede;
        }
      }
    }
  }
}
.section-box {
  background: #ffffff;
  border-radius: 4px;
  .title {
    color: #242424;
    font-size: 15px;
    padding: 10px;
    &.border {
      border-bottom: 1px solid #f7f7f7;
    }
  }
}
.result-info {
  .result-title {
    color: #242424;
    font-size: 15px;
    padding: 0 10px;
  }
  .result-desc {
    padding: 10px;
    margin: 10px;
    font-size: 13px;
    color: @fontColor;
    background: #f0f5ff;
  }
}
</style>
